module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"agreeRecurrent":"I understand that I will be charged on a regular basis","agreePublic":"I accept the ","offer":"terms and conditions","confirm":"Confirm payment"}}')
  delete Component.options._Ctor
}
